import { TableColumnsType, TableProps, Tooltip } from "antd";
import { useLayout } from "hooks/otros/useLayout";
import React, { useCallback, useState, useEffect, useRef, useMemo, startTransition } from "react";
import { useVerifyResponse } from "hooks/otros/useVerifyReponse";
import { optionsPOST, url, url_interna } from "config/constants";
import { useSearchTableNew } from "hooks/otros/useSearchTableNew";
import { TableRowSelection } from "antd/lib/table/interface";
import { useSearchTableNoFilter } from "hooks/otros/useSearchTableNoFilter";
import { IQVIARegistro } from "pages/productos/visormartillo/Iqvia";
import { UltimaCompra } from "pages/productos/visormartillo/UltimasComprasTable";
import { DescuentoDia } from "pages/productos/visormartillo/DescuentoDiaTable";
import { PedidoResumen } from "pages/productos/visormartillo/UltimosPedidosTable";
import { PromocionMF } from "pages/productos/visormartillo/PromocionesMF";
import { PropMargen } from "pages/productos/visormartillo/MargenUltimoTrimestre";
import { ProveedorPromocion } from "pages/productos/visormartillo/PromocionesProveedor";
import { ListOrdenCompra, VisorReporteOrdenCompra } from "hooks/compras/useGenerarOrden";
import Highlighter from "react-highlight-words";
import { optionsPost } from "config/methods";
import Swal from "sweetalert2";
// import TipoPromo from "../../pages/productos/visormartillo/TipoPromo";

const breadcrumbs = [{ Label: "Productos", Url: "/productos" }, { Label: "Visor martillo" }];

const openKeys = [breadcrumbs[0].Label];

export type VisorReporte = {
  COD: number;
  Descripcion: string;
  LAB: string;
  PVP: number;
  Costo: number;
  MrgB: number;
  PVPxMia: number;
  Descu_Mia: number;
  Margen_Mia: number;
  PVPxSG: number;
  Descu_SG: number;
  Margen_SG: number;
  VENTA_MIA: number;
  VENTA_SG: number;
  MAX_Mia: number;
  MAX_SG: number;
  Pedir_Mia: number;
  Pedir_Sg: number;
  Stock_Mia: number;
  Stock_Sg: number;
  G: string;
  R: string;
  P: string;
  PMAC: string;
  C: string;
  key: React.Key;
};

type bodegasReporte = {
  key: number;
  Cod_Bodega: number;
  Bodega: string;
  Stock: number;
  // Min: number;
  MA: number;
  M1: number;
  M2: number;
  M3: number;
  M4: number;
  M5: number;
  M6: number;
  M7: number;
  M8: number;
};

export interface farmaciaStock {
  key: number;
  Cod_Bodega: number;
  Bodega: string;
  cajas: number;
  fracciones: number;
  MA: number;
  M1: number;
  M2: number;
  M3: number;
  M4: number;
  M5: number;
  M6: number;
  M7: number;
  M8: number;
}

export const useVisorMartillo = () => {
  useLayout(breadcrumbs, openKeys, breadcrumbs[0].Label + "/" + breadcrumbs[1].Label);
  const [datos, setDatos] = useState<VisorReporte[]>([]);
  const [sortedData, setSortedData] = useState<VisorReporte[]>([]);

  const [datosStockBodegas, setDatosStockBodegas] = useState<farmaciaStock[]>([]);

  const [datosBodega, setDatosBodega] = useState<bodegasReporte[]>([]);
  const [dataIqvia, setDataIqvia] = useState<IQVIARegistro[]>([]);
  const [ultimasCompras, setUltimasCompras] = useState<UltimaCompra[]>([]);
  const [descuentosDias, setDescuentosDias] = useState<DescuentoDia[]>([]);
  const [ultimosPedidos, setUltimosPedidos] = useState<PedidoResumen[]>([]);

  const [promoProveedor, setPromoProveedor] = useState<ProveedorPromocion[]>();

  const [nameProduct, setNameProduct] = useState<string>("");
  const [namePharma, setNamePharma] = useState<string>("");

  const [promo, setPromo] = useState<PromocionMF | null>(null);
  const [esPromo, setEsPromo] = useState<string>("");
  const [margenes, setMargenes] = useState<PropMargen | null>();
  const [showModalGenOrden, setshowModalGenOrden] = useState<boolean>(false);
  const [showModalStockFarmacias, setshowModalStockFarmacias] = useState<boolean>(false);
  const [dataProductosOrden, setdataProductosOrden] = useState<VisorReporteOrdenCompra[]>([]);
  const { isError } = useVerifyResponse();

  const { getColumnSearchPropsNew: getColumnSearchPropsNewBodegasReporte } = useSearchTableNew<bodegasReporte>();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [loader, setLoader] = useState<boolean>(false);
  const [loaderStock, setLoaderStock] = useState<boolean>(false);

  const tableContainerRef = useRef<HTMLDivElement>(null);

  const tableRef = useRef<HTMLDivElement>(null);
  const vtRef = useRef<any>(null);

  const { getColumnSearchTableNoFilter, searchText, searchedColumn } = useSearchTableNoFilter(datos, vtRef);
  const [activeRowIndex] = useState<number>(0);

  const [selectkeyProveedor, setselectkeyProveedor] = useState<React.Key>();
  const [ordenesCompra, setordenesCompra] = useState<ListOrdenCompra[]>([]);
  const [loaderBtnCompra, setLoaderBtnCompra] = useState<boolean>(false);

  const getDataMartillo = useCallback(async () => {
    try {
      const res = await fetch(
        `${url_interna}api/productos/data_visor_martillo`,
        optionsPOST(JSON.stringify({}), {
          "api-token": "apitoken",
        })
      );
      if (isError(res)) throw new Error();
      const respuesta = await res.json();

      if (respuesta.msg) {
        const respuestas: VisorReporte[] = respuesta.data;
        setDatos(respuestas);
        setSortedData(respuestas);
      } else {
        return { msg: "Ocurrio un error", status: false };
      }
    } catch (e) {
      return { msg: "no_conexion", status: false };
    }
  }, [isError]);

  /*sumar por proveedor para la orden de compra */

  const SumProveedorOrdenCompra = (data: VisorReporteOrdenCompra[]) => {
    let listOrden: ListOrdenCompra[] = [];
    data.forEach((item) => {
      const existe_mia = listOrden.find((item2) => item.Cod_Proveedor === item2.Cod_Proveedor && item2.cadena === "MIA");
      const existe_sg = listOrden.find((item2) => item.Cod_Proveedor === item2.Cod_Proveedor && item2.cadena === "SG");

      if (item.Pedir_Mia > 0 && item.Cod_Proveedor) {
        if (existe_mia) {
          existe_mia.Valor += item.Costo_Proveedor * item.Pedir_Mia;
        } else {
          listOrden.push({
            key: listOrden.length + 1,
            Cod_Proveedor: item.Cod_Proveedor,
            Proveedor: item.Proveedor,
            cadena: "MIA",
            Valor: item.Pedir_Mia * item.Costo_Proveedor,
          });
        }
      }
      if (item.Pedir_Sg > 0 && item.Cod_Proveedor) {
        if (existe_sg) {
          existe_sg.Valor += item.Costo_Proveedor * item.Pedir_Sg;
        } else {
          listOrden.push({
            key: listOrden.length + 1,
            Cod_Proveedor: item.Cod_Proveedor,
            Proveedor: item.Proveedor,
            cadena: "SG",
            Valor: item.Pedir_Sg * item.Costo_Proveedor,
          });
        }
      }
    });
    console.log(listOrden);
    setordenesCompra(listOrden);
  };

  //**/Cambio para arreglar el sorter */
  const handleChange: TableProps<VisorReporte>["onChange"] = (pagination, filters, sorter) => {
    if (!("order" in sorter) || !sorter.order) {
      setSortedData([...datos]);
      return;
    }

    const { columnKey, order } = sorter;

    const sorted = [...datos].sort((a, b) => {
      const valA = a[columnKey as keyof VisorReporte];
      const valB = b[columnKey as keyof VisorReporte];

      const parsedA = typeof valA === "number" ? valA : Number(valA);
      const parsedB = typeof valB === "number" ? valB : Number(valB);

      if (isNaN(parsedA) || isNaN(parsedB)) {
        return order === "ascend" ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
      }

      return order === "ascend" ? parsedA - parsedB : parsedB - parsedA;
    });

    setSortedData(sorted);
  };

  useEffect(() => {
    getDataMartillo();
  }, [getDataMartillo]);

  const getDataBodega = useCallback(
    async (codProducto: React.Key) => {
      console.log(codProducto);
      setPromo(null);
      setMargenes(null);
      setEsPromo("");
      try {
        const res = await fetch(
          `${url_interna}api/productos/data_bodega_producto`,
          optionsPOST(JSON.stringify({ codProducto: codProducto }), {
            "api-token": "apitoken",
          })
        );

        if (isError(res)) throw new Error();
        const respuesta = await res.json();

        if (respuesta.msg) {
          let data = JSON.parse(respuesta.data);
          startTransition(() => {
            setDatosBodega(data[0].stock);
            setDataIqvia(data[0].iqvia);
            setUltimasCompras(data[0].ultimas_compras);
            setDescuentosDias(data[0].des_dias);
            setUltimosPedidos(data[0].ult_pedidos);
            setPromo(data[0].promociones[0]);
            data[0].objetivo && setEsPromo(data[0].objetivo[0].Producto_Objetivo);
            data[0].margen.length > 0 && setMargenes(data[0].margen[0]);
            data[0].promocionesProveedor && setPromoProveedor(data[0].promocionesProveedor);
            setLoader(false);
          });
        } else {
          setLoader(false);
          console.error("Error en la respuesta:", respuesta);
          return { msg: "Ocurrio un error", status: false };
        }
      } catch (e) {
        setLoader(false);
        console.error("Error de conexión:", e);
        return { msg: "no_conexion", status: false };
      }
    },
    [isError]
  );

  const handleSelectionChange = useCallback(
    async (newSelectedRowKeys: React.Key[]) => {
      setLoader(true);
      const currentKey = newSelectedRowKeys[0];
      if (selectedRowKeys?.[0] === currentKey) {
        setSelectedRowKeys([]);
      } else {
        setSelectedRowKeys([currentKey]);

        try {
          getDataBodega(currentKey);
        } catch (error) {
          // console.error("Error al obtener datos:", error);
        } finally {
          // setLoader(false);
        }
      }
    },
    [selectedRowKeys, getDataBodega]
  );

  /*   const OnChangeSelectionProveedor = useCallback(
    async (newSelectedRowKeys: React.Key[]) => {
      setselectkeyProveedor(newSelectedRowKeys[0]);
      console.log(newSelectedRowKeys[0], 'newSelectedRowKeys[0]')
      },[])



  const rowSelectionProveedor: TableRowSelection<ProveedorPromocion> = useMemo(
    () => ({
      selectedRowKeys: selectkeyProveedor !== undefined ? [selectkeyProveedor] : [],
      columnWidth: '20px',
      onChange: OnChangeSelectionProveedor,
      type: "radio",
    }),
    [selectkeyProveedor, OnChangeSelectionProveedor]
  ); */

  const rowSelection: TableRowSelection<VisorReporte> = useMemo(
    () => ({
      selectedRowKeys,
      columnWidth: 0,
      onChange: handleSelectionChange,
      type: "radio",
    }),
    [selectedRowKeys, handleSelectionChange]
  );

  const onRowClick = useCallback(
    (record: VisorReporte) => {
      return {
        onClick: () => {
          setNameProduct(record.Descripcion);
          const newSelectedRowKeys = [record.key];
          handleSelectionChange(newSelectedRowKeys);
        },
      };
    },
    [handleSelectionChange]
  );

  const getStockBodegas = useCallback(
    async (codProducto: React.Key, tipo: number) => {
      try {
        setDatosStockBodegas([]);
        setshowModalStockFarmacias(true);
        setLoaderStock(true);
        setNamePharma(tipo === 3 ? "FARMACIAS SG" : "FARMACIAS MIA");
        const res = await fetch(
          `${url_interna}api/productos/stock_farmacias`,
          optionsPOST(JSON.stringify({ codProducto: codProducto, tipo }), {
            "api-token": "apitoken",
          })
        );
        if (isError(res)) throw new Error();
        const respuesta = await res.json();
        if (respuesta.msg) {
          setDatosStockBodegas(respuesta.data);
        }
        setLoaderStock(false);
      } catch (error) {
        setLoaderStock(false);
      }
    },
    [isError]
  );

  const columns: TableColumnsType<VisorReporte> = [
    {
      title: "Descripción",
      dataIndex: "Descripcion",
      key: "Descripcion",
      width: "220px",
      fixed: "left",
      className: "letraPequenaVisor",
      ...getColumnSearchTableNoFilter("Descripcion"),
      render: (text: string) => {
        const isSearchActive = searchedColumn === "Descripcion" && searchText;

        const highlightedText = isSearchActive ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "var(--primary)",
              padding: 0,
              color: "#fff",
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text?.toString() || ""}
          />
        ) : (
          text
        );

        return (
          <div
            style={{
              maxWidth: "100%",
              fontSize: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <Tooltip
              title={<span style={{ fontSize: "10px" }}>{text}</span>}
              placement='rightBottom'
              getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
              overlayStyle={{
                minWidth: 100,
                maxWidth: "80vw",
                whiteSpace: "normal",
                zIndex: 9999,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  textOverflow: "clip",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  maxWidth: "100%",
                }}
              >
                {highlightedText}
              </span>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "LAB",
      dataIndex: "LAB",
      className: "letraPequenaVisor",
      key: "LAB",
      ...getColumnSearchTableNoFilter("LAB"),
    },
    {
      title: "PVP",
      dataIndex: "PVP",
      key: "PVP",
      sorter: (a, b) => a.PVP - b.PVP,
      align: "right",
    },
    {
      title: "Costo",
      dataIndex: "Costo",
      key: "Costo",
      sorter: (a, b) => a.Costo - b.Costo,
      align: "right",
    },
    {
      title: "MrgB",
      dataIndex: "MrgB",
      key: "MrgB",
      sorter: (a, b) => a.MrgB - b.MrgB,
      align: "right",
    },
    {
      title: "PVPxMia",
      dataIndex: "PVPxMia",
      key: "PVPxMia",
      sorter: (a, b) => a.PVPxMia - b.PVPxMia,
      align: "right",
    },
    {
      title: "Descu_Mia",
      dataIndex: "Descu_Mia",
      key: "Descu_Mia",
      sorter: (a, b) => a.Descu_Mia - b.Descu_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_Mia > record.Descu_Mia ? "transparent" : "#ffc2c2";
        return backgroundColor !== "transparent" ? (
          <Tooltip title='Bajo margen'>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_Mia}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_Mia}</div>
        );
      },
    },
    {
      title: "Marg_Mia",
      dataIndex: "Margen_Mia",
      key: "Margen_Mia",
      sorter: (a, b) => a.Margen_Mia - b.Margen_Mia,
      align: "right",
      render: (text, record, index) => {
        const isAlerta = record.Margen_Mia <= record.Descu_Mia;
        const backgroundColor = isAlerta ? "#ffc2c2" : "transparent";
        const content = <div style={{ backgroundColor, padding: "0 8px" }}>{record.Margen_Mia}</div>;
        return isAlerta ? <Tooltip title='Bajo margen'>{content}</Tooltip> : content;
      },
    },
    {
      title: "PVPxSG",
      dataIndex: "PVPxSG",
      key: "PVPxSG",
      sorter: (a, b) => a.PVPxSG - b.PVPxSG,
      align: "right",
    },
    {
      title: "Descu_SG",
      dataIndex: "Descu_SG",
      key: "Descu_SG",
      sorter: (a, b) => a.Descu_SG - b.Descu_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_SG > record.Descu_SG ? "transparent" : "#ffc2c2";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_SG}</div>;
      },
    },
    {
      title: "Marg_SG",
      dataIndex: "Margen_SG",
      key: "Margen_SG",
      sorter: (a, b) => a.Margen_SG - b.Margen_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_SG > record.Descu_SG ? "transparent" : "#ffc2c2";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Margen_SG}</div>;
      },
    },

    {
      title: "VENTA_MIA",
      dataIndex: "VENTA_MIA",
      key: "VENTA_MIA",
      sorter: (a, b) => a.VENTA_MIA - b.VENTA_MIA,
      align: "right",
      render: (text, record, index) => {
        const ratio = record.VENTA_MIA / record.MAX_Mia - 1;
        const backgroundColor = ratio > 0 ? "#fff176" : ratio < -0.5 ? "#f8bbd0" : "transparent";

        const tooltipText =
          backgroundColor === "#fff176" ? "Subastecimiento" : backgroundColor === "#f8bbd0" ? "SobreStock" : "";

        return backgroundColor !== "transparent" ? (
          <Tooltip title={tooltipText}>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_MIA}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_MIA}</div>
        );
      },
    },
    {
      title: "VENTA_SG",
      dataIndex: "VENTA_SG",
      key: "VENTA_SG",
      sorter: (a, b) => a.VENTA_SG - b.VENTA_SG,
      align: "right",
      render: (text, record, index) => {
        const ratio = record.VENTA_SG / record.MAX_SG - 1;
        const backgroundColor =
          ratio > 0
            ? "#fff176" // amarillo: sobreventa
            : ratio < -0.5
            ? "#f8bbd0" // rosa: muy por debajo del máximo
            : "transparent";

        const tooltipText =
          backgroundColor === "#fff176" ? "Subastecimiento" : backgroundColor === "#f8bbd0" ? "SobreStock" : "";

        return backgroundColor !== "transparent" ? (
          <Tooltip title={tooltipText}>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_SG}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_SG}</div>
        );
      },
    },
    {
      title: "MAX_Mia",
      dataIndex: "MAX_Mia",
      key: "MAX_Mia",
      sorter: (a, b) => a.MAX_Mia - b.MAX_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Mia > record.MAX_Mia ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.MAX_Mia}</div>;
      },
    },
    {
      title: "Stock_Mia",
      dataIndex: "Stock_Mia",
      key: "Stock_Mia",
      sorter: (a, b) => a.Stock_Mia - b.Stock_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Mia > record.MAX_Mia ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Stock_Mia}</div>;
      },
    },
    {
      title: "MAX_SG",
      dataIndex: "MAX_SG",
      key: "MAX_SG",
      sorter: (a, b) => a.MAX_SG - b.MAX_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Sg > record.MAX_SG ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.MAX_SG}</div>;
      },
    },

    {
      title: "Stock_Sg",
      dataIndex: "Stock_Sg",
      key: "Stock_Sg",
      sorter: (a, b) => a.Stock_Sg - b.Stock_Sg,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Sg > record.MAX_SG ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Stock_Sg}</div>;
      },
    },
    {
      title: "Mach",
      dataIndex: "Pedir_Mia",
      key: "Pedir_Mia",
      sorter: (a, b) => a.Pedir_Mia - b.Pedir_Mia,
      align: "right",
    },
    {
      title: "Port",
      dataIndex: "Pedir_Sg",
      key: "Pedir_Sg",
      sorter: (a, b) => a.Pedir_Sg - b.Pedir_Sg,
      align: "right",
    },

    {
      title: "G",
      dataIndex: "G",
      key: "G",
      width: "30px",
      align: "center",
    },
    {
      title: "R",
      dataIndex: "R",
      key: "R",
      width: "30px",
      align: "center",
    },
    {
      title: "P",
      dataIndex: "P",
      key: "P",
      width: "30px",
      align: "center",
    },
    {
      title: "PMAC",
      dataIndex: "PMAC",
      key: "PMAC",
      width: "40px",
      align: "center",
    },
    {
      title: "C",
      dataIndex: "C",
      key: "C",
      width: "30px",
      align: "center",
    },
  ];

  const ColumnsOrden: TableColumnsType<ListOrdenCompra> = [
    {
      title: "Proveedor",
      dataIndex: "Proveedor",
      className: "letraPequenaVisor",
      key: "Bodega",
      width: "100px",
      ellipsis: true,
      render: (text, record) => {
        return (
          <Tooltip
            placement='right'
            overlayStyle={{ fontSize: "10px", padding: 0 }}
            title={record.Proveedor + " (" + record.cadena + ") Total:" + record.Valor.toFixed(2)}
            style={{ fontSize: "8px", padding: 0 }}
          >
            <span>{record.Proveedor + " (" + record.cadena + ")"}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Total",
      dataIndex: "Valor",
      className: "letraPequenaVisor",
      key: "Bodega",
      width: "30px",
      align: "right",
      render: (text, record) => {
        return <span>{record.Valor.toFixed(2)}</span>;
      },
    },
  ];

  const columnsBodega: TableColumnsType<bodegasReporte> = [
    {
      title: "Bodega",
      dataIndex: "Bodega",
      className: "letraPequenaVisor",
      key: "Bodega",
      width: "170px",
      fixed: "left",
      ...getColumnSearchPropsNewBodegasReporte("Bodega"),
      render: (text, record) => {
        const keysClickeables = ["FARMACIAS MIA", "FARMACIAS SG"];
        const esClickeable = keysClickeables.includes(record.Bodega);
        return (
          <span>
            {text}
            {esClickeable && <span style={{ marginLeft: 6, color: "#999" }}>⟶</span>}
          </span>
        );
      },
    },
    {
      title: "Stock",
      dataIndex: "Stock",
      className: "letraPequenaVisor",
      key: "Stock",
      sorter: (a, b) => a.Stock - b.Stock,
      sortDirections: ["descend", "ascend"],
      ...getColumnSearchPropsNewBodegasReporte("Stock"),
    },
    {
      title: "Ma",
      dataIndex: "Ma",
      className: "letraPequenaVisor",
      key: "Ma",
      sorter: (a, b) => a.MA - b.MA,
      sortDirections: ["descend", "ascend"],
      ...getColumnSearchPropsNewBodegasReporte("MA"),
    },
    {
      title: "M1",
      dataIndex: "M1",
      className: "letraPequenaVisor",
      key: "M1",
    },
    {
      title: "M2",
      dataIndex: "M2",
      className: "letraPequenaVisor",
      key: "M2",
    },
    {
      title: "M3",
      dataIndex: "M3",
      className: "letraPequenaVisor",
      key: "M3",
    },
    {
      title: "M4",
      dataIndex: "M4",
      className: "letraPequenaVisor",
      key: "M4",
    },
    {
      title: "M5",
      dataIndex: "M5",
      className: "letraPequenaVisor",
      key: "M5",
    },
    {
      title: "M6",
      dataIndex: "M6",
      className: "letraPequenaVisor",
      key: "M6",
    },
    {
      title: "M7",
      dataIndex: "M7",
      className: "letraPequenaVisor",
      key: "M7",
    },
    {
      title: "M8",
      dataIndex: "M8",
      className: "letraPequenaVisor",
      key: "M8",
    },
  ];

  const handleSendTableCompras = async () => {
    try {
      console.log(dataProductosOrden);
      setLoaderBtnCompra(true);
      const respuesta = await fetch(url + "atencion_cliente/guardar-compra", optionsPost({ json: dataProductosOrden })).then(
        (data) => data.json()
      );

      if (respuesta.msg) {
        let sms = respuesta.detalle;
        Swal.fire("Correcto", `${respuesta.detalle}`, "success");
        setLoaderBtnCompra(false);
        return { sms, status: true };
      } else {
        setLoaderBtnCompra(false);
        Swal.fire("Error", `Ocurrio un error al guardar la compra`, "error");
        return { respuesta: "Ocurrio un error al guardar", status: false };
      }
    } catch (error) {
      setLoaderBtnCompra(false);
      return { msg: "no_conexion", status: false };
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (document.activeElement === tableRef.current || tableRef.current?.contains(document.activeElement)) {
        const currentIndex =
          selectedRowKeys.length > 0 ? sortedData.findIndex((item) => item.key === selectedRowKeys[0]) : -1;

        let newIndex = currentIndex;

        if (event.key === "ArrowDown") {
          event.preventDefault();
          newIndex = currentIndex < sortedData.length - 1 ? currentIndex + 1 : currentIndex;
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
        }

        // Si el índice cambió, actualizar la selección
        if (newIndex !== currentIndex && newIndex >= 0) {
          const newSelectedRowKeys = [sortedData[newIndex].key];
          handleSelectionChange(newSelectedRowKeys);

          const rowElement = tableRef.current?.querySelector(`tr[data-row-key="${sortedData[newIndex].key}"]`);
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: "auto", block: "nearest" });
          }
        }
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.setAttribute("tabindex", "0");
      tableElement.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [selectedRowKeys, sortedData, handleSelectionChange]);

  return {
    margenes,
    promo,
    ultimosPedidos,
    dataIqvia,
    datosBodega,
    vtRef,
    rowSelection,
    selectedRowKeys,
    columns,
    datos,
    onRowClick,
    columnsBodega,
    activeRowIndex,
    tableContainerRef,
    tableRef,
    loader,
    ultimasCompras,
    descuentosDias,
    esPromo,
    showModalGenOrden,
    setshowModalGenOrden,
    dataProductosOrden,
    setdataProductosOrden,
    handleChange,
    sortedData,
    promoProveedor,
    getDataBodega,
    setLoader,
    showModalStockFarmacias,
    setshowModalStockFarmacias,
    getStockBodegas,
    datosStockBodegas,
    loaderStock,
    nameProduct,
    namePharma,
    selectkeyProveedor,
    setselectkeyProveedor,
    //rowSelectionProveedor,
    //OnChangeSelectionProveedor,
    SumProveedorOrdenCompra,
    ordenesCompra,
    ColumnsOrden,
    handleSendTableCompras,
    loaderBtnCompra,
  };
};
